import React from 'react'
import './style.css'

export const CornerRibbon = (props) => (
    <div class="corner-ribbon bottom-left sticky red">
        {props.env} ENVIRONMENT
    </div>
)
